// removed by extract-text-webpack-plugin
module.exports = {"Header":"app__Header--3fVBu","Body":"app__Body--1yXk-","Body-topbar":"app__Body-topbar--16DsA","Body-navPanel":"app__Body-navPanel--2SDfd","Body-main":"app__Body-main--1jmqB","Body-navbar-toggler":"app__Body-navbar-toggler--Wys91","Body-navPanel--in":"app__Body-navPanel--in--3a4us","Body-main--in":"app__Body-main--in--1zwAX","Body-content":"app__Body-content--px7bb"};


//////////////////
// WEBPACK FOOTER
// ./base/app.css
// module id = 165
// module chunks = 0